//Please add the language resource
const yzCompany = {
  originNo: 'originNo',
  originName: 'originName',
  companyCode: 'companyCode',
  companyName: 'companyName',
  createTime: 'createTime',
  creator: 'creator',
  updateTime: 'updateTime',
  updater: 'updater',
};
export default yzCompany



// WEBPACK FOOTER //
// ./src/page/mdm/yzCompany/lang/yzCompany.en.js